import * as toastr from "toastr";
import { SubmitProcessReviewInvoice } from ".";
import { InvoiceDetails, InvoiceSubmissionModel } from "../../Models/ProcessReview/invoiceSubmission";
import * as Services from "../../Services";
import { Reference } from "../../Shared/Constants";
import { SubmitProcessReviewInvoiceCtrl } from "./submitProcessReviewInvoice";

export class SubmitAdditionalInvoiceCtrl extends SubmitProcessReviewInvoiceCtrl<InvoiceSubmissionModel, InvoiceDetails> {
  public static $inject = ["$state", "DocumentApiClient", "ProcessReviewInvoiceApiClient"];

  protected processReviewType: string = Reference.Reference.additionalInvoiceProcessReviewType;

  constructor(
    $state: angular.ui.IStateService,
    documentApiClient: Services.DocumentApiClient.IDocumentApiClient,
    processReviewInvoiceApiClient: Services.ProcessReviewInvoiceApiClient.IProcessReviewInvoiceApiClient,
  ) {
    super($state, documentApiClient, processReviewInvoiceApiClient);
  }

  protected onSubmitError(): void {
    toastr.error("There was an error submitting the invoice.");
  }

  protected onSubmitSuccess(): void {
    toastr.success("Additional invoice submitted!");
  }

  protected validate(): boolean {
    return this.validInvoiceAmount();
  }

  protected getInvoiceSubmission(): InvoiceSubmissionModel {
    return new InvoiceSubmissionModel(this.igsCustomerNumber);
  }

  protected getInvoiceDetails() {
    this.processReviewInvoiceApiClient.getAdditionalInvoiceDetails(this.igsCustomerNumber).then((milestoneDetails) => {
      this.invoiceDetails = milestoneDetails;
    }).catch((error: any) => {
      this.navigateToCustomerPage();
    });
  }

  private validInvoiceAmount = (): boolean => {
    return this.invoiceDetails.invoiceAmount !== 0;
  }
}
